module.exports = __webpack_public_path__ + "static/media/notre-dame.e4ff0fb5.png";